import { useNavigateBare } from 'js/app/hooks/navigate/useNavigate/useNavigateBare';

export const useNavigate = ({ replace = false } = {}) => {
    const navigate = useNavigateBare({ replace });

    return navigate;
};

